import mailing from './mailing';

export default {
    mailing,
    title: {
        ru: 'Контрагент',
        en: 'Contractor',
    },
    sent: {
        ru: 'Письмо отправленно',
        en: 'Email was sent',
    },
    contractor: {
        en: 'Contractor',
        ru: 'Контрагент',
    },
    change: {
        en: 'Contractor change',
        ru: 'Смена контрагента',
    },
    startTypingName: {
        en: 'Start typing name',
        ru: 'Начните вводить название',
    },
};
